import { render, staticRenderFns } from "./ConfirmModal.vue?vue&type=template&id=19a096c5&scoped=true&"
import script from "./ConfirmModal.vue?vue&type=script&lang=ts&"
export * from "./ConfirmModal.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmModal.vue?vue&type=style&index=0&id=19a096c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a096c5",
  null
  
)

export default component.exports